import SingleChoiceV1 from "../../../../components/form_builder/elements/single_choice/SingleChoiceV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-single-choice-v1",
  component: SingleChoiceV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      options: [],
      description: "",
      value: "",
      required: false,
      hidden: false,
      showInline: false,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 120,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
